export default __webpack_public_path__ + "static/media/eeyyyyy.924f5aab.gif";